import { makeStyles, mergeClasses, tokens } from "@fluentui/react-components";
import { appTokens } from "./Styles/appTokens";

const useStyles = makeStyles({
    titleDiv: {
        fontSize: '1.25em',
        margin: 'auto',
        color: tokens.colorBrandStroke1,
    },
    titleWhite: {
        color: appTokens.verticalMenu.menuItemColor
    },
    title1: {
        fontWeight: '200',
    },
    title2: {
        fontWeight: '500',
    },
    title3: {
        fontWeight: 'bold',
    },
    tm: {
        fontWeight: 'lighter',
        fontSize: '.4em',        
    }
});

export interface LogoProps {
    white?: boolean;
    className?: string;
}
const Logo = (props: LogoProps) => {

    const { white = false, className } = props;

    //Styles
    const styles = useStyles();
    const titleDivClasses = mergeClasses(
        styles.titleDiv,
        !!white && styles.titleWhite,
        className
    )

    return (
        <div className={titleDivClasses} data-testid="app-logo">
            <span className={styles.title1}>the</span>
            <span className={styles.title2}>Case</span>
            <span className={styles.title3}>Work</span>
            <sup className={styles.tm}>TM</sup>
        </div>
    );
}

export const CasePortalLogo = (props: LogoProps) => {
    const styles = useStyles();
    const titleDivClasses = mergeClasses(
        styles.titleDiv,
        !!props.white && styles.titleWhite,
        props.className
    );
    return (
        <div className={titleDivClasses} style={{margin:'unset'}} data-testid="app-logo">
            <span className={styles.title1}>the</span>
            <span className={styles.title2}>Case</span>
            <span className={styles.title3}>Portal</span>
        </div>
    );
}

export default Logo;